/**
 * P0 Support Ticket API
 * Endpoints for support ticket system
 */
import axiosInstance from './axiosInstance';

const BASE = '/core/support/';

export const supportApi = {
  /**
   * Get list of support tickets
   * @returns {Promise} List of user's support tickets
   */
  list: () => 
    axiosInstance.get(BASE).then((r) => r.data),

  /**
   * Get single support ticket by ID
   * @param {string} id - Ticket ID
   * @returns {Promise} Ticket details
   */
  get: (id) => 
    axiosInstance.get(`${BASE}${id}/`).then((r) => r.data),

  /**
   * Create support ticket
   * @param {Object} data - Ticket data
   * @param {string} data.subject - Subject line
   * @param {string} data.description - Ticket description
   * @param {string} data.priority - Priority: 'low', 'medium', 'high', 'urgent'
   * @returns {Promise} Created ticket
   */
  create: (data) => 
    axiosInstance.post(BASE, data).then((r) => r.data),

  /**
   * Update support ticket
   * @param {string} id - Ticket ID
   * @param {Object} data - Updated ticket data
   * @returns {Promise} Updated ticket
   */
  update: (id, data) => 
    axiosInstance.patch(`${BASE}${id}/`, data).then((r) => r.data),

  /**
   * Resolve support ticket (staff only)
   * @param {string} id - Ticket ID
   * @param {string} resolution - Resolution message
   * @returns {Promise} Resolved ticket
   */
  resolve: (id, resolution) => 
    axiosInstance.post(`${BASE}${id}/resolve/`, { resolution }).then((r) => r.data),

  /**
   * Delete support ticket
   * @param {string} id - Ticket ID
   * @returns {Promise} Deletion confirmation
   */
  delete: (id) => 
    axiosInstance.delete(`${BASE}${id}/`).then((r) => r.data),
};

export default supportApi;

